/**
 * @flow
 * @relayHash b486aa4f81c7d7e0c75916406dbdb041
 */

/* eslint-disable */

'use strict'

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentTypeWhere = {|
  and?: ?$ReadOnlyArray<?PaymentTypeWhere>,
  or?: ?$ReadOnlyArray<?PaymentTypeWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  name?: ?ConditionInputType,
  description?: ?ConditionInputType,
  type?: ?ConditionInputType,
  companyId?: ?ConditionInputType,
  managerId?: ?ConditionInputType,
  checkbookCorrelative?: ?ConditionInputType,
  isDisabled?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  updatedAt?: ?ConditionInputType,
  updatedBy?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type PaymentTypeSelectQueryVariables = {|
  where?: ?PaymentTypeWhere
|};
export type PaymentTypeSelectQueryResponse = {|
  +paymentTypes: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |}
|};
export type PaymentTypeSelectQuery = {|
  variables: PaymentTypeSelectQueryVariables,
  response: PaymentTypeSelectQueryResponse,
|};
*/

/*
query PaymentTypeSelectQuery(
  $where: PaymentTypeWhere
) {
  paymentTypes(where: $where, orderBy: [code], order: ASC) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'where',
        type: 'PaymentTypeWhere',
        defaultValue: null,
      },
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'paymentTypes',
        storageKey: null,
        args: [
          {
            kind: 'Literal',
            name: 'order',
            value: 'ASC',
          },
          {
            kind: 'Literal',
            name: 'orderBy',
            value: ['code'],
          },
          {
            kind: 'Variable',
            name: 'where',
            variableName: 'where',
          },
        ],
        concreteType: 'PaymentTypeConnection',
        plural: false,
        selections: [
          {
            kind: 'LinkedField',
            alias: null,
            name: 'edges',
            storageKey: null,
            args: null,
            concreteType: 'PaymentTypeEdge',
            plural: true,
            selections: [
              {
                kind: 'LinkedField',
                alias: null,
                name: 'node',
                storageKey: null,
                args: null,
                concreteType: 'PaymentType',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'id',
                    args: null,
                    storageKey: null,
                  },
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'name',
                    args: null,
                    storageKey: null,
                  },
                ],
              },
            ],
          },
        ],
      },
    ]
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'PaymentTypeSelectQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/),
    },
    operation: {
      kind: 'Operation',
      name: 'PaymentTypeSelectQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/),
    },
    params: {
      operationKind: 'query',
      name: 'PaymentTypeSelectQuery',
      id: null,
      text:
        'query PaymentTypeSelectQuery(\n  $where: PaymentTypeWhere\n) {\n  paymentTypes(where: $where, orderBy: [code], order: ASC) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n',
      metadata: {},
    },
  }
})()
// prettier-ignore
;(node/*: any*/).hash = '5700999f191ac2455c7b225bff06f698';
module.exports = node
